import button from './ExportButton.vue'
const ExportButton = {
  install: function (Vue) {
    Vue.component('ExportButton', button)
  }
}
export default ExportButton
